import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // on déclare les variable que l'on veut stocker
    //Page 0 = accueil
    current_page: "accueil",
    current_question: "0",
    // historique pour btn retour
    history: [],
    // age enfant, ado, adulte
    age: null,
    // genre, aventure, scifi, ...
    genre: null,
    // fréquence de lecture
    freqLecture: null,
    // style préféré, bc, manga, ...
    typeLecture: null,
    // envie histoire complete
    oneShot: false,
    // envie non connue
    envieNC: null,
    // surprenez moi
    suprise: null,
    // offSet de la query
    offSet: 0,
    // offSet via la fréquence de lecture
    offSetFreq: 0,
    // nombre de propositions renvoyées par la query
    range: 5,
    componentKey: 0,
    loading: false,
    cpt_new_res: 0,
    scenario: 0,
    classic: false
  },
  mutations: {
    // update valeur "current_page", lorsqu'on appelle la fonction
    SET_CURRENTPAGE(state, value) {
      state.current_page = value;
    },
    SET_CURRENTQUESTION(state, value) {
      state.current_question = value;
    },
    SET_ADDHISTORY(state, value) {
      state.history.push(value);
    },
    SET_BACKHISTORY(state) {
      state.history.pop();
    },
    SET_RESETHISTORY(state) {
      state.history = [];
    },
    SET_AGE(state, value) {
      state.age = value;
    },
    SET_GENRE(state, value) {
      state.genre = value;
    },
    SET_FREQLECTURE(state, value) {
      state.freqLecture = value;
    },
    SET_TYPELECTURE(state, value) {
      state.typeLecture = value;
    },
    SET_ONESHOT(state, value) {
      state.oneShot = value;
    },
    SET_SURPRISE(state, value) {
      state.surprise = value;
    },
    SET_INITOFFSET(state, value) {
      state.offSet = value;
    },
    SET_OFFSET(state, value) {
      state.offSet += value;
    },
    SET_OFFSETFREQ(state, value) {
      state.offSetFreq = value;
    },
    RESET_OFFSET(state) {
      state.offSet = 0;
    },
    SET_RANGE(state, value) {
      state.range = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_COMPONENTKEY(state) {
      state.componentKey += 1;
    },
    SET_SCENARIO(state, value) {
      state.scenario = value;
    },
    SET_CLASSIC(state, value) {
      state.classic = value;
    },
    SET_CPTNEWRES(state, value) {
      state.cpt_new_res = value;
    },
    SET_RIEN() {}
  }
});
